import { InsuredInformationBreadcrumb } from 'quick-quote/components'
import RiderGroup from 'quick-quote/product-common/coverage-plan/components/rider/rider-group'
import TotalPremiumInput from 'quick-quote/product-common/coverage-plan/components/basic-plan/total-premium-input'
import PATH from 'quick-quote/constants/path'
import { Redirect } from 'react-router-dom'
import ModelFactorSelection from 'quick-quote/product-common/coverage-plan/components/basic-plan/model-factor-selection'
import BasicPlan from 'quick-quote/product-common/coverage-plan/components/basic-plan/basic-plan'
import UltimateGrowthProductSelection from './ultimate-growth-product-selection'
import VALUES from 'core/data-model/constants/values'

const CoveragePlan = ({
  toggleRider,
  riderCodes,
  canProceedToCoveragePlan,
  editRiderSumAssured,
  editRiderSelectedPlan,
  infoMessage,
  productCode,
}) => {
  if (!canProceedToCoveragePlan) {
    return <Redirect to={PATH.PRODUCT_SELECTION} push />
  }
  return (
    <div>
      <InsuredInformationBreadcrumb />
      <div id="coverage-plan">
        <div className="content">
          <div id="basic-plan">
            <div className="content">
              <ModelFactorSelection />
              {VALUES.ULTIMATE_GROWTH_CODE_GROUP.includes(productCode) ? <UltimateGrowthProductSelection /> : <div />}
              <BasicPlan />
            </div>
          </div>
          <div id="total-premium">
            <TotalPremiumInput />
          </div>
          <RiderGroup
            riderCodes={riderCodes}
            toggleRider={toggleRider}
            editRiderSumAssured={editRiderSumAssured}
            editRiderSelectedPlan={editRiderSelectedPlan}
            infoMessage={infoMessage}
          />
        </div>
      </div>
    </div>
  )
}

export default CoveragePlan
